(() => {
  'use strict';
  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  function init(scope = document) {
    scope.querySelectorAll('[data-k2-buying-details]').forEach((box) => {
      if (box.dataset.k2BuyingReady) return;
      box.dataset.k2BuyingReady = 'true';
      const section = box.closest('.cc-main-product');
      const source = box.querySelector('[data-k2-buying-source]');
      const facts = box.querySelector('[data-k2-buying-facts]');
      if (!section || !source || !facts) return;
      // Quote complete, concise source paragraphs/list items; never synthesize claims.
      const lines = [...source.content.querySelectorAll('li, p')]
        .filter((node) => !node.querySelector('li, p'))
        .map((node) => clean(node.textContent))
        .filter((text) => text.length > 8 && text.length <= 240);
      const includes = lines.find((text) => /\b(?:package includes|package contents|what(?: is|'s) included|complete\b.{0,55}\bset\b|includes\s*:)/i.test(text));
      const checks = [...new Set(lines.filter((text) => text !== includes && /\b(?:not included|without the|not compatible|does not fit|not for|excluding|excludes|except for|final sale|non-returnable)\b/i.test(text)))].slice(0, 2);
      function row(label, texts) {
        if (!texts.length) return;
        const wrap = document.createElement('div');
        const term = document.createElement('dt');
        const value = document.createElement('dd');
        term.textContent = label;
        texts.forEach((text, index) => {
          if (index) value.appendChild(document.createElement('br'));
          const line = document.createElement('span');
          line.textContent = text;
          value.appendChild(line);
        });
        wrap.append(term, value);
        facts.appendChild(wrap);
      }
      row('Included', includes ? [includes] : []);
      row('Check before ordering', checks);
      facts.hidden = !facts.children.length;
      section.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        let destination;
        if (link.hasAttribute('data-k2-open-description')) {
          destination = section.querySelector('[data-k2-description-anchor]');
          const toggle = destination?.querySelector('[data-k2-desc-toggle]');
          if (toggle && toggle.getAttribute('aria-expanded') === 'false') toggle.click();
          const disclosure = destination?.querySelector('details');
          if (disclosure) disclosure.open = true;
        } else if (link.hasAttribute('data-k2-open-warranty')) {
          destination = section.querySelector('[data-k2-policy-source="both"], [data-k2-policy-source="warranty"]');
          const disclosure = destination?.querySelector('details');
          if (disclosure) disclosure.open = true;
        } else if (link.hasAttribute('data-k2-open-reviews')) {
          destination = document.getElementById('looxReviewsFrame') || document.getElementById('looxReviews');
        }
        if (!destination) return; // Keep real URL/contact fallback when a section is absent.
        event.preventDefault();
        let ancestor = destination.closest('details');
        while (ancestor) {
          ancestor.open = true;
          ancestor = ancestor.parentElement?.closest('details');
        }
        destination.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
